module.exports = __webpack_public_path__ + "icon-linkedin@2x.png?1f19a0ce2639f2861f046d8298f4a544";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-linkedin@2x.png
// module id = 207
// module chunks = 0